import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, isRef as _isRef, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-5 ml-4 textappBAR"
}
const _hoisted_2 = { class: "preTitle" }
const _hoisted_3 = {
  key: 1,
  class: "mt-5 ml-4 textappBAR"
}

import { computed, onMounted, Ref, ref, watch } from "vue";
import router from "@/router";

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useTheme, useDisplay } from "vuetify";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import { STRINGS } from "@/interfaces/SmartLink/General";

/**
 * Component
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'AppBar',
  setup(__props) {

const { xs, mdAndUp, mdAndDown, smAndDown } = useDisplay();
const theme = useTheme();

/********************************
 ************ STORE *************
 *******************************/
const store = useStore();

/********************************
 ************ I18N **************
 *******************************/
let { locale, t } = useI18n();

/********************************
 ********** INTERFACES **********
 *******************************/
const nameBar: Ref<STRINGS> = ref({
  SmartLinkAntucoya: "MINERA ANTUCOYA",
  SmartLinkZaldivar: "MINERA ZALDIVAR",
  SmartLinkMaster: "MINERA CANANEA",
  SmartLinkCananea: "MINERA CANANEA",
  SmartLinkNacozari: "MINERA NACOZARI",
  SmartLinkHCGROUP: "MINERA DEMO",
  SmartLinkDEMO: "MINERA DEMO",
  SmartLinkMasterFront: "MINERA DEMO",
  SmartLinkCMDIC: "MINERA CMDIC",
  SmartLinkIOT: "MINERA IOT",
  SmartLinkTepeaca: "CEMENTERA TEPEACA"
});

const projectName = computed(() => store.state.projectName);
const finaltitleBar = ref(nameBar.value[projectName.value ?? ""]);

const colorPick = ref(null);

const items = ref([
  { title: computed(() => t("logout")) },
  // {title : computed( () => t('logout') )}
]);
const language = ref([
  { title: computed(() => t("appBar.es")), value: "es" },
  { title: computed(() => t("appBar.en")), value: "en" },
]);

const themeSwitch = ref(false);

watch(themeSwitch, (p: boolean) => {
  setTimeout(() => {
    localStorage.setItem("appTheme", p.toString());
    let themeSelect = "";
    p ? (themeSelect = "darkCustom") : (themeSelect = "lightCustom");
    theme.change(themeSelect)
  }, 100);
});

watch(colorPick, (color) => {
  if (theme.global.name.value === "darkCustom") {
    theme.themes.value.darkCustom.colors.background = color ?? "";
  }
  if (theme.global.name.value === "lightCustom") {
    theme.themes.value.lightCustom.colors.background = color ?? "";
  }
});

const changeDrawer = () => {
  store.commit("showDrawer");
};

const pressItem = (item: number) => {
  if (item === 0) { // Cerrar Sesión
    // 1. Obtener el rol guardado en LocalStorage
    const userRol = localStorage.getItem("rol");

    // 2. Redireccionar según el rol del usuario
    if (userRol === "desarrollador") {
      // Si es programador/desarrollador, va a la selección de minas
      router.push("/principalPage");
      store.commit("setAppBarPage", "principalPage");
    } else {
       localStorage.removeItem("user");
      localStorage.removeItem("rol");
      store.commit("setUserSesion", null);
      // store.commit("setUserRol", null);
      // Si es trabajador de mina (o cualquier otro usuario), va al Login
      router.push("/login");
      store.commit("setAppBarPage", "loginPage");
    }

    theme.change("darkCustom");
  }
  if (item === 1) {
    if (theme.global.name.value === "darkCustom") {
      theme.themes.value.darkCustom.colors.background = "#FF00FF";
    }
    if (theme.global.name.value === "lightCustom") {
      theme.themes.value.lightCustom.colors.background = "#FF0000";
    }
  }
};

onMounted(() => {
  let themeSelect = "";
  localStorage.getItem("appTheme") === null
    ? localStorage.setItem("appTheme", "true")
    : null;
  setTimeout(() => {
    themeSwitch.value = localStorage.getItem("appTheme")?.toString() === "true";
    themeSwitch.value
      ? (themeSelect = "darkCustom")
      : (themeSelect = "lightCustom");
    theme.global.name.value = themeSelect;
  }, 500);
});

return (_ctx: any,_cache: any) => {
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createBlock(_component_v_row, {
    class: "appBarComp ma-0",
    justify: "space-between"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_sheet, {
        color: "transparent",
        style: _normalizeStyle(_unref(smAndDown) ? 'width: 150px ' : 'width: calc(100% - 200px);')
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_sheet, {
            color: "transparent",
            width: "630"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, { class: "ma-0" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_sheet, {
                    width: "90",
                    color: "transparent",
                    height: "65"
                  }, {
                    default: _withCtx(() => [
                      (_unref(mdAndDown))
                        ? (_openBlock(), _createBlock(_component_v_app_bar_nav_icon, {
                            key: 0,
                            class: "mt-2",
                            color: "white",
                            variant: "text",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (changeDrawer()))
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  (_unref(mdAndUp) && projectName.value !== 'SmartLinkRAOS')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                        _cache[4] || (_cache[4] = _createTextVNode(" SMARTLINK V2.6 | ", -1)),
                        _createElementVNode("span", _hoisted_2, _toDisplayString(finaltitleBar.value), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(mdAndUp) && projectName.value === 'SmartLinkRAOS')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_3, " SMARTLINK RAOS "))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["style"]),
      _createVNode(_component_v_sheet, {
        class: "languageCard",
        color: "transparent"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, {
            class: "ma-0 py-3",
            justify: "end",
            "align-content": "center"
          }, {
            default: _withCtx(() => [
              (!_unref(xs))
                ? (_openBlock(), _createBlock(_component_v_select, {
                    key: 0,
                    class: "languageSelect",
                    modelValue: _unref(locale),
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(locale) ? (locale).value = $event : locale = $event)),
                    items: language.value,
                    "item-title": "title",
                    "item-value": "value",
                    density: "compact",
                    variant: "outlined",
                    "hide-details": "",
                    style: {"width":"110px !important"}
                  }, null, 8, ["modelValue", "items"]))
                : _createCommentVNode("", true),
              _createVNode(_component_v_menu, {
                "close-on-content-click": false,
                transition: "slide-x-transition"
              }, {
                activator: _withCtx(({ props, isActive }) => [
                  _createVNode(_component_v_btn, _mergeProps({
                    "append-icon": isActive ? 'mdi-chevron-left' : 'mdi-chevron-down',
                    color: "colorText"
                  }, props), {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { icon: "mdi-cog-outline" })
                    ]),
                    _: 1
                  }, 16, ["append-icon"])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list, {
                    lines: false,
                    density: "compact",
                    nav: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_switch, {
                            modelValue: themeSwitch.value,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((themeSwitch).value = $event)),
                            "append-icon": "mdi-weather-night",
                            "prepend-icon": "mdi-white-balance-sunny",
                            "hide-details": ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      (_unref(xs))
                        ? (_openBlock(), _createBlock(_component_v_list_item, { key: 0 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_select, {
                                class: "mb-3",
                                modelValue: _unref(locale),
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(locale) ? (locale).value = $event : locale = $event)),
                                items: language.value,
                                "item-title": "title",
                                "item-value": "value",
                                density: "compact",
                                variant: "outlined",
                                "hide-details": "",
                                style: {"width":"110px !important"}
                              }, null, 8, ["modelValue", "items"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, i) => {
                        return (_openBlock(), _createBlock(_component_v_list_item, {
                          style: 'text-align:center',
                          key: i,
                          link: "",
                          onClick: ($event: any) => (pressItem(i))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.title), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})